import React, { useEffect, useMemo, useState } from 'react';
import {
  CheckCircle2,
  Clock3,
  ShieldAlert,
  XCircle,
  Users,
  Car,
  Euro,
  CalendarDays,
  Search,
  RefreshCw,
  Download,
  Trash2,
  Mail,
  X,
  Pause,
  Play,
  Eye,
  ChevronLeft,
  ChevronRight,
  Star,
  Zap,
  History,
  BadgeCheck,
  LayoutDashboard,
  Menu,
  Megaphone,
  Handshake,
  Building2,
  Settings,
  Tag,
  Percent,
  Receipt,
  Undo2,
  MessageSquare,
  Flag,
  Cookie,
  BarChart3,
  Database,
  Rocket,
  BellRing,
  ShieldOff,
  FileText,
  LineChart,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import api from '@/lib/axios';
import MarketplaceSettingsPanel from '@/components/marketplace/MarketplaceSettingsPanel';
import MarketplaceCommercePanel from '@/components/marketplace/MarketplaceCommercePanel';
import MarketplaceSalesAdminPanel from '@/components/marketplace/MarketplaceSalesAdminPanel';
import MarketplaceNoticesPanel from '@/components/marketplace/MarketplaceNoticesPanel';
import MarketplaceLegalSettingsPanel from '@/components/marketplace/MarketplaceLegalSettingsPanel';
import MarketplaceDenunciasPanel from '@/components/marketplace/MarketplaceDenunciasPanel';
import MarketplaceConversationsAdminPanel from '@/components/marketplace/MarketplaceConversationsAdminPanel';
import MarketplacePartnersAdminPanel from '@/components/marketplace/MarketplacePartnersAdminPanel';
import MarketplaceOverviewPanel from '@/components/marketplace/MarketplaceOverviewPanel';
import MarketplaceInfluencersPanel from '@/components/marketplace/MarketplaceInfluencersPanel';
import MarketplaceAuditPanel from '@/components/marketplace/MarketplaceAuditPanel';
import MarketplaceAdsAdminPanel from '@/components/marketplace/MarketplaceAdsAdminPanel';
import MarketplaceBoostsPanel from '@/components/marketplace/MarketplaceBoostsPanel';
import MarketplaceAlertsPanel from '@/components/marketplace/MarketplaceAlertsPanel';
import MarketplaceEmailTemplatesPanel from '@/components/marketplace/MarketplaceEmailTemplatesPanel';
import MarketplaceSuppressionPanel from '@/components/marketplace/MarketplaceSuppressionPanel';
import MarketplaceCmsPanel from '@/components/marketplace/MarketplaceCmsPanel';
import MarketplaceAnalyticsPanel from '@/components/marketplace/MarketplaceAnalyticsPanel';
import MarketplaceLaunchReadinessPanel from '@/components/marketplace/MarketplaceLaunchReadinessPanel';
import MarketplaceRefundsPanel from '@/components/marketplace/MarketplaceRefundsPanel';
import MarketplaceNewsPanel from '@/components/marketplace/MarketplaceNewsPanel';
import { MarketplaceAudiencePanel } from '@/components/marketplace/MarketplaceAudiencePanel';

const ADMIN_SECTIONS = [
  { grupo: 'Painel', itens: [
    { key: 'visao-geral', label: 'Visão geral', icon: LayoutDashboard },
    { key: 'audiencia', label: 'Audiência do site', icon: Users },
    { key: 'estatisticas', label: 'Estatísticas', icon: BarChart3 },
  ] },
  { grupo: 'Anúncios', itens: [
    { key: 'anuncios-aluguer', label: 'Anúncios de aluguer', icon: Car },
    { key: 'anuncios-venda', label: 'Anúncios de venda', icon: Tag },
    { key: 'motoristas', label: 'Motoristas', icon: Users },
    { key: 'registos', label: 'Registos e validações', icon: Database },
  ] },
  { grupo: 'Entidades', itens: [
    { key: 'stands', label: 'Stands', icon: Building2 },
    { key: 'parceiros', label: 'Parceiros', icon: Handshake },
    { key: 'associacoes', label: 'Associações', icon: Users },
  ] },
  { grupo: 'Comunicação', itens: [
    { key: 'conversas', label: 'Conversas', icon: MessageSquare },
    { key: 'denuncias', label: 'Denúncias', icon: Flag },
  ] },
  { grupo: 'Comercial', itens: [
    { key: 'produtos-precos', label: 'Produtos e preços', icon: Tag },
    { key: 'promocoes', label: 'Promoções', icon: Percent },
    { key: 'boosts', label: 'Boosts por email', icon: Rocket },
    { key: 'parcerias', label: 'Parcerias de divulgação', icon: Handshake },
    { key: 'publicidade', label: 'Publicidade', icon: Megaphone },
    { key: 'encomendas', label: 'Encomendas', icon: Receipt },
    { key: 'pagamentos', label: 'Pagamentos', icon: Euro },
    { key: 'reembolsos', label: 'Reembolsos', icon: Undo2 },
  ] },
  { grupo: 'Marketing', itens: [
    { key: 'alertas', label: 'Alertas "Avise-me"', icon: BellRing },
    { key: 'email-templates', label: 'Templates de email', icon: Mail },
    { key: 'conteudo-cms', label: 'Conteúdo (CMS)', icon: FileText },
    { key: 'noticias-info', label: 'Notícias e informação', icon: FileText },
    { key: 'analitica', label: 'Analítica / Google', icon: LineChart },
  ] },
  { grupo: 'Sistema', itens: [
    { key: 'preparacao-lancamento', label: 'Preparação p/ lançamento', icon: Rocket },
    { key: 'consentimentos', label: 'Consentimentos', icon: Cookie },
    { key: 'supressao', label: 'Lista de supressão', icon: ShieldOff },
    { key: 'legal', label: 'Identificação legal', icon: BadgeCheck },
    { key: 'configuracoes', label: 'Configurações', icon: Settings },
    { key: 'auditoria', label: 'Auditoria', icon: History },
  ] },
];

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const resolveImageUrl = (src) => {
  if (!src) return '';
  if (src.startsWith('data:') || src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/api/')) return `${BACKEND_URL}${src}`;
  return src;
};

export default function MarketplaceAdminPage({ initialSection }) {
  const [dashboard, setDashboard] = useState(null);
  const [status, setStatus] = useState('pendente');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [registos, setRegistos] = useState([]);
  const [registosLoading, setRegistosLoading] = useState(false);
  const [regTipo, setRegTipo] = useState('');
  const [regStatus, setRegStatus] = useState('');
  const [regQuery, setRegQuery] = useState('');

  const [historyMode, setHistoryMode] = useState('diario');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  // Modal de mensagem direta admin → anunciante
  const [msgModal, setMsgModal] = useState({ open: false, item: null, assunto: '', corpo: '', sending: false });

  // Modal de detalhes do anúncio (admin view-only) + lightbox de fotos
  const [detailItem, setDetailItem] = useState(null);
  const [photoIndex, setPhotoIndex] = useState(0);

  // Fase 1 — modal de histórico/auditoria do anúncio
  const [historyModal, setHistoryModal] = useState({ open: false, item: null, entries: [], loading: false });

  // Fase 6 — navegação por secções do painel
  const [section, setSection] = useState(() => initialSection || (window.location.hash || '').replace('#', '') || 'visao-geral');
  const [navOpen, setNavOpen] = useState(false);
  const goTo = (key) => {
    setSection(key);
    setNavOpen(false);
    window.location.hash = key;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Fase 21 — estatísticas de consentimento de cookies
  const [consentStats, setConsentStats] = useState(null);
  const loadConsentStats = async () => {
    try {
      const response = await api.get('/admin/marketplace/consent-stats');
      setConsentStats(response.data);
    } catch (err) {
      /* silencioso — secção opcional */
    }
  };

  const loadDashboard = async () => {
    try {
      const response = await api.get('/admin/marketplace/dashboard');
      setDashboard(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao carregar dashboard.');
    }
  };

  const loadItems = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.get('/admin/marketplace/publicacoes', { params: { status } });
      setItems(response.data.items || []);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao carregar moderação.');
    } finally {
      setLoading(false);
    }
  };

  const loadRegistos = async () => {
    setRegistosLoading(true);
    try {
      const params = { page: 1, limit: 200 };
      if (regTipo) params.tipo = regTipo;
      if (regStatus) params.status = regStatus;
      if (regQuery.trim()) params.query = regQuery.trim();
      const response = await api.get('/admin/marketplace/registos', { params });
      setRegistos(response.data.items || []);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao carregar registos.');
    } finally {
      setRegistosLoading(false);
    }
  };

  useEffect(() => {
    loadItems();
    loadDashboard();
    loadRegistos();
    loadConsentStats();
  }, [status]);

  const updateStatus = async (id, nextStatus) => {
    const motivo = nextStatus === 'rejeitado'
      ? window.prompt('Motivo da rejeição:') || 'Rejeitado por moderação'
      : '';

    setError('');
    setMessage('');
    try {
      await api.put(`/admin/marketplace/publicacoes/${id}/status`, { status: nextStatus, motivo });
      setMessage(`Publicação ${nextStatus} com sucesso.`);
      loadItems();
      loadDashboard();
      loadRegistos();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao atualizar status.');
    }
  };

  const markPayment = async (item, statusPagamento = 'pago') => {
    let valorPago = item.payment?.required_amount || 0;
    let dataPagamento = null;
    let metodo = '';

    if (statusPagamento === 'pago') {
      const valueInput = window.prompt('Valor pago (€):', String(valorPago));
      if (valueInput === null) return;
      valorPago = Number(valueInput || 0);
      if (Number.isNaN(valorPago) || valorPago < 0) {
        setError('Valor pago inválido.');
        return;
      }
      const dateInput = window.prompt('Data pagamento ISO (opcional):', '');
      dataPagamento = dateInput || null;
      metodo = window.prompt('Método (opcional):', '') || '';
    }

    try {
      await api.put(`/admin/marketplace/publicacoes/${item.id}/pagamento`, {
        status: statusPagamento,
        valor_pago: statusPagamento === 'pago' ? valorPago : 0,
        data_pagamento: dataPagamento,
        metodo,
      });
      setMessage(`Pagamento atualizado (${statusPagamento}).`);
      loadDashboard();
      loadItems();
      loadRegistos();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao atualizar pagamento.');
    }
  };

  const deleteListing = async (item) => {
    if (!window.confirm(`Apagar definitivamente o anúncio "${item.titulo}"? Esta acção não pode ser desfeita.`)) return;
    try {
      await api.delete(`/admin/marketplace/publicacoes/${item.id}`);
      setMessage('Anúncio apagado.');
      loadDashboard();
      loadItems();
      loadRegistos();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao apagar anúncio.');
    }
  };

  const requestProlongation = async (item) => {
    const nome = `${item.contacto?.primeiro_nome || ''} ${item.contacto?.ultimo_nome || ''}`.trim() || 'o anunciante';
    if (!window.confirm(`Enviar email a ${nome} (${item.contacto?.email}) a perguntar se quer prolongar o anúncio "${item.titulo}"?`)) return;
    try {
      const res = await api.post(`/admin/marketplace/publicacoes/${item.id}/prolongar`);
      if (res.data?.email_sent) {
        setMessage(`Email de prolongamento enviado para ${res.data.email}.`);
      } else {
        setMessage(`Pedido registado. O envio do email pode ter falhado — verifique manualmente.`);
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao pedir prolongamento.');
    }
  };

  const openMessageModal = (item) => {
    const nome = `${item.contacto?.primeiro_nome || ''}`.trim() || 'Anunciante';
    setMsgModal({
      open: true,
      item,
      assunto: `Sobre o seu anúncio "${item.titulo}"`,
      corpo: `Olá ${nome},\n\n`,
      sending: false,
    });
  };

  const sendAdminMessage = async () => {
    if (!msgModal.item) return;
    if (!msgModal.assunto.trim() || !msgModal.corpo.trim()) {
      setError('Preencha o assunto e a mensagem.');
      return;
    }
    setMsgModal((s) => ({ ...s, sending: true }));
    try {
      await api.post(`/admin/marketplace/publicacoes/${msgModal.item.id}/mensagem`, {
        assunto: msgModal.assunto,
        mensagem: msgModal.corpo,
      });
      setMessage(`Mensagem enviada para ${msgModal.item.contacto?.email}.`);
      setMsgModal({ open: false, item: null, assunto: '', corpo: '', sending: false });
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao enviar mensagem.');
      setMsgModal((s) => ({ ...s, sending: false }));
    }
  };

  const toggleFlag = async (item, flag) => {
    setError('');
    try {
      const current = !!(item.flags && item.flags[flag]);
      await api.put(`/admin/marketplace/publicacoes/${item.id}/flags`, { [flag]: !current });
      setMessage(`Etiqueta "${flag}" ${!current ? 'ativada' : 'desativada'}.`);
      loadItems();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao atualizar etiqueta.');
    }
  };

  const toggleSeloIdentidade = async (item) => {
    setError('');
    try {
      const current = !!(item.selos?.identidade?.ativo);
      await api.put(`/admin/marketplace/publicacoes/${item.id}/selos`, { identidade_verificada: !current });
      setMessage(`Selo interno de identidade ${!current ? 'atribuído' : 'removido'} (uso interno — nunca é mostrado ao público).`);
      loadItems();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao atualizar selo.');
    }
  };

  const [selosModal, setSelosModal] = useState(null); // { item, docs:Set, nota }
  const openSelosModal = (item) => {
    setSelosModal({
      item,
      docs: new Set(item.selos?.documentacao?.documentos || []),
      nota: item.selos?.documentacao?.nota || '',
    });
  };
  const saveSelosDocs = async (ativo) => {
    if (!selosModal) return;
    setError('');
    try {
      await api.put(`/admin/marketplace/publicacoes/${selosModal.item.id}/selos`, {
        documentacao_verificada: ativo,
        documentos: Array.from(selosModal.docs),
        nota: selosModal.nota,
      });
      setMessage(`Selo "Documentação verificada" ${ativo ? 'atribuído' : 'removido'}.`);
      setSelosModal(null);
      loadItems();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao guardar selo.');
    }
  };

  const expirarAnuncio = async (item) => {
    if (!window.confirm(`Expirar já o anúncio "${item.titulo}"?`)) return;
    setError('');
    try {
      await api.post(`/admin/marketplace/publicacoes/${item.id}/acao`, { acao: 'expirar' });
      setMessage('Anúncio expirado.');
      loadItems();
      loadDashboard();
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao expirar anúncio.');
    }
  };

  const openHistory = async (item) => {
    setHistoryModal({ open: true, item, entries: [], loading: true });
    try {
      const res = await api.get(`/admin/marketplace/publicacoes/${item.id}/historico`);
      setHistoryModal({ open: true, item, entries: res.data?.historico || [], loading: false });
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao carregar histórico.');
      setHistoryModal({ open: false, item: null, entries: [], loading: false });
    }
  };

  const exportServerCsv = async (kind) => {
    const path = kind === 'pagamentos' ? 'pagamentos' : 'publicacoes';
    try {
      const res = await api.get(`/admin/marketplace/export/${path}.csv`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `marketplace-${path}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError('Erro ao exportar CSV.');
    }
  };

  const exportRegistosCsv = () => {
    const headers = ['ID', 'Tipo', 'Status', 'Nome', 'Email', 'Telefone', 'Cidade', 'Pagamento', 'Valor Previsto', 'Valor Pago', 'Data Pagamento', 'Criado em'];
    const rows = registos.map((item) => {
      const nome = `${item.contacto?.primeiro_nome || ''} ${item.contacto?.ultimo_nome || ''}`.trim();
      return [
        item.id,
        item.tipo,
        item.status,
        nome,
        item.contacto?.email || '',
        item.contacto?.telefone || '',
        item.cidade || '',
        item.payment?.status || '',
        item.payment?.required_amount || 0,
        item.payment?.paid_amount || 0,
        item.payment?.paid_at || '',
        item.created_at || '',
      ];
    });

    const csv = [headers, ...rows]
      .map((row) => row.map((cell) => `"${String(cell ?? '').replaceAll('"', '""')}"`).join(','))
      .join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'marketplace-registos.csv';
    link.click();
    URL.revokeObjectURL(url);
  };

  const historyRows = useMemo(() => {
    if (!dashboard?.historico) return [];
    return dashboard.historico[historyMode] || [];
  }, [dashboard, historyMode]);

  const maxRegistosHistory = useMemo(() => {
    if (!historyRows.length) return 1;
    return Math.max(...historyRows.map((row) => row.registos || 0), 1);
  }, [historyRows]);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="marketplace-admin-page">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex w-full max-w-[1500px] items-center justify-between gap-3 px-4 py-3 md:px-6">
          <div className="flex items-center gap-2">
            <button type="button" onClick={() => setNavOpen((v) => !v)}
              className="inline-flex items-center justify-center rounded-xl border border-slate-200 p-2 text-slate-700 lg:hidden"
              aria-label={navOpen ? 'Fechar menu' : 'Abrir menu'} aria-expanded={navOpen}
              data-testid="marketplace-admin-nav-toggle">
              {navOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
            </button>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-wide text-emerald-700">Marketplace TVDE</p>
              <h1 className="text-xl font-black text-slate-900" data-testid="marketplace-admin-title">Centro de controlo</h1>
            </div>
          </div>
          <Link to="/" className="rounded-xl border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700" data-testid="marketplace-admin-back-marketplace">
            Ver marketplace
          </Link>
        </div>
      </header>

      <div className="mx-auto flex w-full max-w-[1500px] gap-6 px-4 py-6 md:px-6">
        <nav className={`${navOpen ? 'block' : 'hidden'} fixed inset-x-0 top-[57px] z-30 max-h-[70vh] overflow-y-auto border-b border-slate-200 bg-white p-3 lg:static lg:z-auto lg:block lg:max-h-none lg:w-64 lg:shrink-0 lg:overflow-visible lg:border-0 lg:bg-transparent lg:p-0`}
          data-testid="marketplace-admin-nav">
          <div className="space-y-4 lg:sticky lg:top-[72px]">
            {ADMIN_SECTIONS.map((grupo) => (
              <div key={grupo.grupo}>
                <p className="px-2 text-[10px] font-bold uppercase tracking-wide text-slate-400">{grupo.grupo}</p>
                <ul className="mt-1 space-y-0.5">
                  {grupo.itens.map(({ key, label, icon: Icon }) => (
                    <li key={key}>
                      <button type="button" onClick={() => goTo(key)}
                        className={`flex w-full items-center gap-2 rounded-xl px-2.5 py-2 text-left text-xs font-semibold transition ${
                          section === key ? 'bg-emerald-600 text-white shadow-sm' : 'text-slate-600 hover:bg-white hover:text-emerald-700'}`}
                        data-testid={`admin-nav-${key}`}>
                        <Icon className="h-3.5 w-3.5 shrink-0" /> {label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </nav>

        <main className="min-w-0 flex-1 space-y-5" data-testid="marketplace-admin-main">
          {section === 'visao-geral' && <MarketplaceOverviewPanel onGoTo={goTo} />}
          {section === 'audiencia' && <MarketplaceAudiencePanel />}
          {section === 'legal' && <MarketplaceLegalSettingsPanel />}
          {section === 'configuracoes' && (
            <>
              <MarketplaceSettingsPanel />
              <MarketplaceNoticesPanel />
              <MarketplaceLegalSettingsPanel />
            </>
          )}
          {section === 'produtos-precos' && <MarketplaceCommercePanel initialTab="produtos" />}
          {section === 'promocoes' && <MarketplaceCommercePanel initialTab="campanhas" />}
          {(section === 'encomendas' || section === 'pagamentos') && <MarketplaceCommercePanel initialTab="encomendas" />}
          {section === 'reembolsos' && <MarketplaceRefundsPanel />}
          {section === 'anuncios-venda' && <MarketplaceSalesAdminPanel initialFilters={{ finalidade: 'venda' }} />}
          {section === 'anuncios-aluguer' && <MarketplaceSalesAdminPanel initialFilters={{ finalidade: 'aluguer' }} />}
          {section === 'motoristas' && <MarketplaceSalesAdminPanel initialFilters={{ finalidade: '', categoria: 'motorista' }} />}
          {section === 'denuncias' && <MarketplaceDenunciasPanel />}
          {section === 'conversas' && <MarketplaceConversationsAdminPanel />}
          {section === 'stands' && <MarketplacePartnersAdminPanel initialTipo="stand" />}
          {section === 'parceiros' && <MarketplacePartnersAdminPanel />}
          {section === 'associacoes' && <MarketplacePartnersAdminPanel initialTipo="associacao" />}
          {section === 'parcerias' && <MarketplaceInfluencersPanel />}
          {section === 'auditoria' && <MarketplaceAuditPanel />}
          {section === 'publicidade' && <MarketplaceAdsAdminPanel />}
          {section === 'boosts' && <MarketplaceBoostsPanel />}
          {section === 'alertas' && <MarketplaceAlertsPanel />}
          {section === 'email-templates' && <MarketplaceEmailTemplatesPanel />}
          {section === 'conteudo-cms' && <MarketplaceCmsPanel />}
          {section === 'noticias-info' && <MarketplaceNewsPanel />}
          {section === 'analitica' && <MarketplaceAnalyticsPanel />}
          {section === 'preparacao-lancamento' && <MarketplaceLaunchReadinessPanel />}
          {section === 'supressao' && <MarketplaceSuppressionPanel />}

          {section === 'estatisticas' && (
          <>
        {dashboard && (
          <section className="grid gap-3 md:grid-cols-4" data-testid="marketplace-admin-dashboard-cards">
            <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4" data-testid="marketplace-admin-card-vehicles">
              <Car className="mb-2 h-5 w-5 text-emerald-700" />
              <p className="text-xs uppercase tracking-wide text-emerald-700">Viaturas</p>
              <p className="text-3xl font-bold text-emerald-800">{dashboard.totais.viaturas}</p>
              <p className="text-sm text-emerald-700">Total publicadas</p>
            </div>
            <div className="rounded-2xl border border-cyan-200 bg-cyan-50 p-4" data-testid="marketplace-admin-card-drivers">
              <Users className="mb-2 h-5 w-5 text-cyan-700" />
              <p className="text-xs uppercase tracking-wide text-cyan-700">Motoristas</p>
              <p className="text-3xl font-bold text-cyan-800">{dashboard.totais.motoristas}</p>
              <p className="text-sm text-cyan-700">Total registados</p>
            </div>
            <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4" data-testid="marketplace-admin-card-pending">
              <Clock3 className="mb-2 h-5 w-5 text-amber-700" />
              <p className="text-xs uppercase tracking-wide text-amber-700">Pendentes</p>
              <p className="text-3xl font-bold text-amber-800">{dashboard.totais.pendentes}</p>
              <p className="text-sm text-amber-700">Para validação</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-100 p-4" data-testid="marketplace-admin-card-leads">
              <Users className="mb-2 h-5 w-5 text-slate-700" />
              <p className="text-xs uppercase tracking-wide text-slate-700">Leads</p>
              <p className="text-3xl font-bold text-slate-900">{dashboard.totais.leads}</p>
              <p className="text-sm text-slate-600">Contactos recebidos</p>
            </div>
          </section>
        )}

        {dashboard && (
          <section className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="marketplace-admin-finance-panel">
            <h2 className="text-lg font-bold text-slate-900" data-testid="marketplace-admin-finance-title">Financeiro Marketplace</h2>
            <div className="mt-3 grid gap-3 md:grid-cols-4">
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="marketplace-admin-finance-free-flag">
                <CalendarDays className="mb-2 h-5 w-5 text-slate-700" />
                <p className="text-xs text-slate-600">Campanha</p>
                <p className="font-semibold text-slate-900">
                  {dashboard.financeiro.campanha_gratuita_ativa ? 'Gratuita ativa' : 'Cobranca ativa'}
                </p>
                <p className="text-xs text-slate-600">Termina em: {dashboard.financeiro.campanha_gratuita_termina_em}</p>
              </div>
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="marketplace-admin-finance-expected">
                <Euro className="mb-2 h-5 w-5 text-slate-700" />
                <p className="text-xs text-slate-600">Valor previsto</p>
                <p className="text-2xl font-bold text-slate-900">€ {dashboard.financeiro.valor_previsto.toFixed(2)}</p>
              </div>
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="marketplace-admin-finance-received">
                <Euro className="mb-2 h-5 w-5 text-slate-700" />
                <p className="text-xs text-slate-600">Valor recebido</p>
                <p className="text-2xl font-bold text-slate-900">€ {dashboard.financeiro.valor_recebido.toFixed(2)}</p>
              </div>
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="marketplace-admin-finance-total-posts">
                <p className="text-xs text-slate-600">Anúncios totais</p>
                <p className="text-2xl font-bold text-slate-900">{dashboard.totais.anuncios_total}</p>
                <p className="text-xs text-slate-600">Aprovados: {dashboard.totais.aprovados} · Rejeitados: {dashboard.totais.rejeitados}</p>
              </div>
            </div>

            <div className="mt-3 grid gap-3 md:grid-cols-3" data-testid="marketplace-admin-gains-cards">
              <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-3" data-testid="marketplace-admin-gain-day">
                <p className="text-xs text-emerald-700">Ganhos do dia</p>
                <p className="text-xl font-bold text-emerald-800">€ {dashboard.ganhos.dia.toFixed(2)}</p>
              </div>
              <div className="rounded-xl border border-cyan-200 bg-cyan-50 p-3" data-testid="marketplace-admin-gain-week">
                <p className="text-xs text-cyan-700">Ganhos da semana</p>
                <p className="text-xl font-bold text-cyan-800">€ {dashboard.ganhos.semana.toFixed(2)}</p>
              </div>
              <div className="rounded-xl border border-indigo-200 bg-indigo-50 p-3" data-testid="marketplace-admin-gain-month">
                <p className="text-xs text-indigo-700">Ganhos do mês</p>
                <p className="text-xl font-bold text-indigo-800">€ {dashboard.ganhos.mes.toFixed(2)}</p>
              </div>
            </div>

            <div className="mt-4 rounded-xl border border-slate-200 p-3" data-testid="marketplace-admin-history-panel">
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
                <p className="text-sm font-semibold text-slate-800" data-testid="marketplace-admin-history-title">Histórico de registos e ganhos</p>
                <div className="flex gap-2">
                  <button onClick={() => setHistoryMode('diario')} className={`rounded-lg px-3 py-1 text-xs font-semibold ${historyMode === 'diario' ? 'bg-emerald-500 text-white' : 'bg-slate-100 text-slate-700'}`} data-testid="marketplace-admin-history-daily-button">Diário</button>
                  <button onClick={() => setHistoryMode('semanal')} className={`rounded-lg px-3 py-1 text-xs font-semibold ${historyMode === 'semanal' ? 'bg-emerald-500 text-white' : 'bg-slate-100 text-slate-700'}`} data-testid="marketplace-admin-history-weekly-button">Semanal</button>
                  <button onClick={() => setHistoryMode('mensal')} className={`rounded-lg px-3 py-1 text-xs font-semibold ${historyMode === 'mensal' ? 'bg-emerald-500 text-white' : 'bg-slate-100 text-slate-700'}`} data-testid="marketplace-admin-history-monthly-button">Mensal</button>
                </div>
              </div>

              <div className="space-y-2" data-testid="marketplace-admin-history-list">
                {historyRows.map((row) => (
                  <div key={row.label} className="grid grid-cols-[120px_1fr_auto_auto] items-center gap-2 text-xs" data-testid={`marketplace-admin-history-row-${row.label}`}>
                    <span className="font-semibold text-slate-700">{row.label}</span>
                    <div className="h-2 rounded bg-slate-100">
                      <div className="h-2 rounded bg-emerald-500" style={{ width: `${Math.max(8, ((row.registos || 0) / maxRegistosHistory) * 100)}%` }} />
                    </div>
                    <span className="rounded bg-slate-100 px-2 py-1" data-testid={`marketplace-admin-history-registers-${row.label}`}>{row.registos} reg.</span>
                    <span className="rounded bg-emerald-50 px-2 py-1 text-emerald-700" data-testid={`marketplace-admin-history-revenue-${row.label}`}>€ {(row.recebido || 0).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
          </>
          )}

          {section === 'consentimentos' && (
        <>
        {consentStats && (
          <section className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="marketplace-admin-consent-section">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="text-lg font-bold text-slate-900" data-testid="marketplace-admin-consent-title">Consentimento de cookies (RGPD)</h3>
              <button onClick={loadConsentStats} className="inline-flex items-center gap-2 rounded-xl border border-slate-300 px-3 py-2 text-xs" data-testid="marketplace-admin-consent-refresh">
                <RefreshCw className="h-4 w-4" /> Atualizar
              </button>
            </div>
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="consent-total">
                <p className="text-xs font-medium text-slate-500">Decisões registadas</p>
                <p className="mt-1 text-2xl font-extrabold text-slate-900">{consentStats.total}</p>
              </div>
              <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-3" data-testid="consent-analytics">
                <p className="text-xs font-medium text-emerald-700">Aceitam Analytics</p>
                <p className="mt-1 text-2xl font-extrabold text-emerald-700">{consentStats.analytics_rate}%</p>
                <p className="text-xs text-emerald-600">{consentStats.analytics_granted}/{consentStats.total}</p>
              </div>
              <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-3" data-testid="consent-ads">
                <p className="text-xs font-medium text-emerald-700">Aceitam Publicidade</p>
                <p className="mt-1 text-2xl font-extrabold text-emerald-700">{consentStats.ads_rate}%</p>
                <p className="text-xs text-emerald-600">{consentStats.ads_granted}/{consentStats.total}</p>
              </div>
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="consent-breakdown">
                <p className="text-xs font-medium text-slate-500">Repartição</p>
                <p className="mt-1 text-sm font-semibold text-slate-800">Aceitaram tudo: {consentStats.accept_all}</p>
                <p className="text-sm font-semibold text-slate-800">Rejeitaram tudo: {consentStats.reject_all}</p>
                <p className="text-sm font-semibold text-slate-800">Personalizado: {consentStats.custom}</p>
              </div>
            </div>
            <div className="mt-4">
              <p className="mb-2 text-xs font-semibold text-slate-500">Últimos 30 dias (decisões por dia)</p>
              {(!consentStats.daily || consentStats.daily.length === 0) ? (
                <p className="text-sm text-slate-400" data-testid="consent-empty">Sem dados ainda. Aparece aqui assim que os visitantes decidirem sobre cookies.</p>
              ) : (
                <div className="flex h-24 items-end gap-1" data-testid="consent-daily-chart">
                  {consentStats.daily.map((d) => {
                    const max = Math.max(...consentStats.daily.map((x) => x.total), 1);
                    return (
                      <div
                        key={d.day}
                        className="flex h-full flex-1 flex-col items-center justify-end"
                        title={`${d.day}: ${d.total} decisões (${d.analytics} analytics, ${d.ads} ads)`}
                      >
                        <div className="w-full rounded-t bg-emerald-500" style={{ height: `${Math.max(4, (d.total / max) * 100)}%` }} />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </section>
        )}
        </>
        )}

        {section === 'registos' && (
        <>
        <section className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="marketplace-admin-registered-section">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <h3 className="text-lg font-bold" data-testid="marketplace-admin-registered-title">Dados dos registados</h3>
            <div className="flex gap-2">
              <button onClick={loadRegistos} className="inline-flex items-center gap-2 rounded-xl border border-slate-300 px-3 py-2 text-xs" data-testid="marketplace-admin-registered-refresh">
                <RefreshCw className="h-4 w-4" /> Atualizar
              </button>
              <button onClick={exportRegistosCsv} className="inline-flex items-center gap-2 rounded-xl border border-emerald-300 bg-emerald-50 px-3 py-2 text-xs text-emerald-700" data-testid="marketplace-admin-export-csv">
                <Download className="h-4 w-4" /> Exportar CSV
              </button>
              <button onClick={() => exportServerCsv('publicacoes')} className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-3 py-2 text-xs text-slate-700" data-testid="marketplace-admin-export-listings-server">
                <Download className="h-4 w-4" /> Anúncios (CSV)
              </button>
              <button onClick={() => exportServerCsv('pagamentos')} className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-3 py-2 text-xs text-slate-700" data-testid="marketplace-admin-export-payments-server">
                <Download className="h-4 w-4" /> Pagamentos (CSV)
              </button>
            </div>
          </div>

          <div className="mb-3 grid gap-2 md:grid-cols-4">
            <select value={regTipo} onChange={(e) => setRegTipo(e.target.value)} className="rounded-xl border border-slate-300 px-3 py-2 text-sm" data-testid="marketplace-admin-filter-type">
              <option value="">Tipo (todos)</option>
              <option value="viatura">Viatura</option>
              <option value="motorista">Motorista</option>
            </select>
            <select value={regStatus} onChange={(e) => setRegStatus(e.target.value)} className="rounded-xl border border-slate-300 px-3 py-2 text-sm" data-testid="marketplace-admin-filter-status">
              <option value="">Estado (todos)</option>
              <option value="pendente">Pendente</option>
              <option value="aprovado">Aprovado</option>
              <option value="rejeitado">Rejeitado</option>
            </select>
            <input value={regQuery} onChange={(e) => setRegQuery(e.target.value)} className="rounded-xl border border-slate-300 px-3 py-2 text-sm" placeholder="Pesquisar nome/email/telefone/cidade" data-testid="marketplace-admin-filter-query" />
            <button onClick={loadRegistos} className="inline-flex items-center justify-center gap-2 rounded-xl bg-slate-900 px-3 py-2 text-sm font-semibold text-white" data-testid="marketplace-admin-apply-filters">
              <Search className="h-4 w-4" /> Filtrar
            </button>
          </div>

          {registosLoading ? (
            <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-4 text-sm" data-testid="marketplace-admin-registered-loading">A carregar registos...</div>
          ) : registos.length === 0 ? (
            <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-4 text-sm" data-testid="marketplace-admin-registered-empty">Sem registos para este filtro.</div>
          ) : (
            <div className="overflow-auto" data-testid="marketplace-admin-registered-table-wrapper">
              <table className="min-w-full text-left text-xs" data-testid="marketplace-admin-registered-table">
                <thead>
                  <tr className="border-b border-slate-200 text-slate-600">
                    <th className="px-2 py-2">Nome</th>
                    <th className="px-2 py-2">Tipo</th>
                    <th className="px-2 py-2">Estado</th>
                    <th className="px-2 py-2">Pagamento</th>
                    <th className="px-2 py-2">Valor</th>
                    <th className="px-2 py-2">Data Pag.</th>
                    <th className="px-2 py-2">Contacto</th>
                    <th className="px-2 py-2">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {registos.map((item) => {
                    const nome = `${item.contacto?.primeiro_nome || ''} ${item.contacto?.ultimo_nome || ''}`.trim();
                    return (
                      <tr key={item.id} className="border-b border-slate-100" data-testid={`marketplace-admin-registered-row-${item.id}`}>
                        <td className="px-2 py-2">
                          <p className="font-semibold text-slate-800" data-testid={`marketplace-admin-reg-name-${item.id}`}>{nome || item.titulo}</p>
                          <p className="text-slate-500">{item.cidade}</p>
                        </td>
                        <td className="px-2 py-2" data-testid={`marketplace-admin-reg-type-${item.id}`}>{item.tipo}</td>
                        <td className="px-2 py-2" data-testid={`marketplace-admin-reg-status-${item.id}`}>{item.status}</td>
                        <td className="px-2 py-2" data-testid={`marketplace-admin-reg-payment-status-${item.id}`}>{item.payment?.status || '—'}</td>
                        <td className="px-2 py-2" data-testid={`marketplace-admin-reg-payment-amount-${item.id}`}>€ {Number(item.payment?.paid_amount || 0).toFixed(2)}</td>
                        <td className="px-2 py-2" data-testid={`marketplace-admin-reg-payment-date-${item.id}`}>{item.payment?.paid_at ? item.payment.paid_at.slice(0, 10) : '—'}</td>
                        <td className="px-2 py-2">
                          <p data-testid={`marketplace-admin-reg-email-${item.id}`}>{item.contacto?.email || '—'}</p>
                          <p data-testid={`marketplace-admin-reg-phone-${item.id}`}>{item.contacto?.telefone || '—'}</p>
                        </td>
                        <td className="px-2 py-2">
                          <div className="flex flex-wrap gap-1">
                            <button onClick={() => markPayment(item, 'pago')} className="rounded-lg border border-emerald-300 bg-emerald-50 px-2 py-1 text-[11px] text-emerald-700" data-testid={`marketplace-admin-reg-mark-paid-${item.id}`}>Marcar pago</button>
                            <button onClick={() => markPayment(item, 'pendente')} className="rounded-lg border border-amber-300 bg-amber-50 px-2 py-1 text-[11px] text-amber-700" data-testid={`marketplace-admin-reg-mark-pending-${item.id}`}>Pendente</button>
                            <button
                              onClick={() => openMessageModal(item)}
                              title="Enviar email ao anunciante"
                              className="inline-flex items-center justify-center rounded-lg border border-cyan-300 bg-cyan-50 px-2 py-1 text-[11px] text-cyan-700 hover:bg-cyan-100"
                              data-testid={`marketplace-admin-reg-message-${item.id}`}
                            >
                              <Mail className="h-3.5 w-3.5" />
                            </button>
                            <button
                              onClick={() => deleteListing(item)}
                              title="Apagar anúncio"
                              className="inline-flex items-center justify-center rounded-lg border border-red-300 bg-red-50 px-2 py-1 text-[11px] font-bold text-red-700 hover:bg-red-100"
                              data-testid={`marketplace-admin-reg-delete-${item.id}`}
                            >
                              <X className="h-3.5 w-3.5" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </section>

        <section className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="marketplace-admin-filters">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h3 className="text-lg font-bold" data-testid="marketplace-admin-validation-title">Painel de validação de anúncios</h3>
          </div>

          <div className="mt-3 flex flex-wrap items-center gap-3">
            <Clock3 className="h-4 w-4 text-emerald-700" />
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm"
              data-testid="marketplace-admin-status-filter"
            >
              <option value="pendente">Pendentes</option>
              <option value="aprovado">Aprovados</option>
              <option value="rejeitado">Rejeitados</option>
              <option value="suspenso">Suspensos</option>
              <option value="expirado">Expirados</option>
            </select>
            <button onClick={loadItems} className="rounded-xl border border-emerald-300 px-3 py-2 text-sm text-emerald-700" data-testid="marketplace-admin-refresh-button">
              Atualizar
            </button>
          </div>
        </section>

        {message && (
          <div className="rounded-xl border border-emerald-300 bg-emerald-50 px-4 py-3 text-sm text-emerald-800" data-testid="marketplace-admin-success-message">
            {message}
          </div>
        )}
        {error && (
          <div className="rounded-xl border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="marketplace-admin-error-message">
            {error}
          </div>
        )}

        {loading ? (
          <section className="rounded-2xl border border-slate-200 bg-white p-6 text-sm" data-testid="marketplace-admin-loading">
            A carregar publicações...
          </section>
        ) : items.length === 0 ? (
          <section className="rounded-2xl border border-slate-200 bg-white p-6 text-sm" data-testid="marketplace-admin-empty-state">
            Sem publicações neste estado.
          </section>
        ) : (
          <section className="grid gap-4 md:grid-cols-2" data-testid="marketplace-admin-listings-grid">
            {items.map((item) => (
              <article key={item.id} className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid={`marketplace-admin-card-${item.id}`}>
                {item.tipo === 'viatura' && item.detalhes?.fotos?.[0] && (
                  <button
                    type="button"
                    onClick={() => { setDetailItem(item); setPhotoIndex(0); }}
                    className="block w-full text-left"
                    data-testid={`marketplace-admin-card-image-btn-${item.id}`}
                  >
                    <img src={resolveImageUrl(item.detalhes.fotos[0])} alt={item.titulo} className="h-40 w-full object-cover transition hover:opacity-90" data-testid={`marketplace-admin-card-image-${item.id}`} />
                  </button>
                )}
                <div className="space-y-3 p-4">
                  <div className="flex items-center justify-between gap-3">
                    <button
                      type="button"
                      onClick={() => { setDetailItem(item); setPhotoIndex(0); }}
                      className="text-left font-bold hover:text-emerald-600"
                      data-testid={`marketplace-admin-card-title-${item.id}`}
                    >
                      {item.titulo}
                    </button>
                    <span className={`rounded-full px-3 py-1 text-xs ${item.status === 'suspenso' ? 'bg-amber-100 text-amber-700' : 'bg-slate-100'}`} data-testid={`marketplace-admin-card-status-${item.id}`}>
                      {item.estado_normalizado || item.status}
                      {item.flags?.destaque ? ' ★' : ''}
                      {item.flags?.urgente ? ' ⚡' : ''}
                    </span>
                  </div>

                  <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700" data-testid={`marketplace-admin-card-contact-${item.id}`}>
                    <p><strong>Nome:</strong> {item.contacto?.primeiro_nome} {item.contacto?.ultimo_nome}</p>
                    <p><strong>Email:</strong> {item.contacto?.email}</p>
                    <p><strong>Telefone:</strong> {item.contacto?.telefone}</p>
                    <p><strong>Cidade:</strong> {item.cidade}</p>
                    <p><strong>Selo:</strong> {item.verified_badge_label || 'Verificado por email'}</p>
                    <p data-testid={`marketplace-admin-card-payment-${item.id}`}><strong>Pagamento:</strong> {item.payment?.status || 'isento_lancamento'} · € {Number(item.payment?.paid_amount || 0).toFixed(2)}</p>
                    <p data-testid={`marketplace-admin-card-payment-date-${item.id}`}><strong>Data pagamento:</strong> {item.payment?.paid_at ? item.payment.paid_at.slice(0, 10) : '—'}</p>
                    {item.expires_at && (
                      <p className={`mt-1 ${new Date(item.expires_at) < new Date() ? 'font-bold text-red-700' : 'text-slate-700'}`} data-testid={`marketplace-admin-card-expiry-${item.id}`}>
                        <strong>Expira em:</strong>{' '}
                        {new Date(item.expires_at).toLocaleDateString('pt-PT', { day: '2-digit', month: 'short', year: 'numeric' })}
                        {' '}({item.duracao_dias || 30} dias)
                        {new Date(item.expires_at) < new Date() && ' · EXPIRADO'}
                      </p>
                    )}
                  </div>

                  {item.tipo === 'viatura' ? (
                    <p className="text-sm text-emerald-700" data-testid={`marketplace-admin-card-price-${item.id}`}>
                      {item.detalhes?.valor_semanal}€ / semana · {item.plano?.label}
                    </p>
                  ) : (
                    <p className="text-sm text-cyan-700" data-testid={`marketplace-admin-card-driver-${item.id}`}>
                      {item.detalhes?.tipo_viatura} · {item.detalhes?.combustivel} · {item.detalhes?.interesse}
                    </p>
                  )}

                  {item.motivo_rejeicao && (
                    <p className="text-xs text-red-700" data-testid={`marketplace-admin-card-reason-${item.id}`}>
                      Motivo: {item.motivo_rejeicao}
                    </p>
                  )}

                  <div className="flex flex-wrap gap-2">
                    <button
                      onClick={() => { setDetailItem(item); setPhotoIndex(0); }}
                      className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50"
                      data-testid={`marketplace-admin-view-${item.id}`}
                    >
                      <Eye className="h-4 w-4" /> Ver detalhes
                    </button>
                    <button
                      onClick={() => updateStatus(item.id, 'aprovado')}
                      className="inline-flex items-center gap-2 rounded-xl bg-emerald-500 px-3 py-2 text-xs font-semibold text-white hover:bg-emerald-600"
                      data-testid={`marketplace-admin-approve-${item.id}`}
                    >
                      <CheckCircle2 className="h-4 w-4" /> {item.status === 'suspenso' ? 'Reativar' : 'Aprovar'}
                    </button>
                    {item.status !== 'suspenso' && (
                      <button
                        onClick={() => updateStatus(item.id, 'suspenso')}
                        className="inline-flex items-center gap-2 rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-800 hover:bg-amber-100"
                        data-testid={`marketplace-admin-suspend-${item.id}`}
                      >
                        <Pause className="h-4 w-4" /> Suspender
                      </button>
                    )}
                    <button
                      onClick={() => updateStatus(item.id, 'rejeitado')}
                      className="inline-flex items-center gap-2 rounded-xl bg-red-500 px-3 py-2 text-xs font-semibold text-white hover:bg-red-600"
                      data-testid={`marketplace-admin-reject-${item.id}`}
                    >
                      <XCircle className="h-4 w-4" /> Rejeitar
                    </button>
                    <button
                      onClick={() => updateStatus(item.id, 'pendente')}
                      className="inline-flex items-center gap-2 rounded-xl border border-slate-600 px-3 py-2 text-xs font-semibold"
                      data-testid={`marketplace-admin-pending-${item.id}`}
                    >
                      <ShieldAlert className="h-4 w-4" /> Pendente
                    </button>
                    <button
                      onClick={() => markPayment(item, 'pago')}
                      className="inline-flex items-center gap-2 rounded-xl border border-emerald-300 bg-emerald-50 px-3 py-2 text-xs font-semibold text-emerald-700"
                      data-testid={`marketplace-admin-pay-${item.id}`}
                    >
                      Marcar Pago
                    </button>
                    <button
                      onClick={() => openMessageModal(item)}
                      className="inline-flex items-center gap-2 rounded-xl border border-cyan-300 bg-cyan-50 px-3 py-2 text-xs font-semibold text-cyan-700 hover:bg-cyan-100"
                      data-testid={`marketplace-admin-message-${item.id}`}
                    >
                      <Mail className="h-4 w-4" /> Mensagem
                    </button>
                    <button
                      onClick={() => requestProlongation(item)}
                      className="inline-flex items-center gap-2 rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-700 hover:bg-amber-100"
                      data-testid={`marketplace-admin-prolong-${item.id}`}
                    >
                      <Clock3 className="h-4 w-4" /> Prolongar
                    </button>
                    <button
                      onClick={() => deleteListing(item)}
                      className="inline-flex items-center gap-2 rounded-xl border border-red-300 bg-red-50 px-3 py-2 text-xs font-semibold text-red-700 hover:bg-red-100"
                      data-testid={`marketplace-admin-delete-${item.id}`}
                    >
                      <Trash2 className="h-4 w-4" /> Apagar
                    </button>
                    <button
                      onClick={() => toggleFlag(item, 'destaque')}
                      className={`inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-xs font-semibold ${item.flags?.destaque ? 'border-yellow-400 bg-yellow-100 text-yellow-800' : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'}`}
                      data-testid={`marketplace-admin-flag-destaque-${item.id}`}
                    >
                      <Star className="h-4 w-4" /> Destaque
                    </button>
                    <button
                      onClick={() => toggleFlag(item, 'urgente')}
                      className={`inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-xs font-semibold ${item.flags?.urgente ? 'border-orange-400 bg-orange-100 text-orange-800' : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'}`}
                      data-testid={`marketplace-admin-flag-urgente-${item.id}`}
                    >
                      <Zap className="h-4 w-4" /> Urgente
                    </button>
                    <button
                      onClick={() => toggleSeloIdentidade(item)}
                      className={`inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-xs font-semibold ${item.selos?.identidade?.ativo ? 'border-indigo-400 bg-indigo-100 text-indigo-800' : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'}`}
                      data-testid={`marketplace-admin-selo-identidade-${item.id}`}
                    >
                      <BadgeCheck className="h-4 w-4" /> Identidade
                    </button>
                    <button
                      onClick={() => openSelosModal(item)}
                      className={`inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-xs font-semibold ${item.selos?.documentacao?.ativo ? 'border-emerald-500 bg-emerald-100 text-emerald-800' : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'}`}
                      data-testid={`marketplace-admin-selo-docs-${item.id}`}
                    >
                      <BadgeCheck className="h-4 w-4" /> Documentação
                    </button>
                    <button
                      onClick={() => expirarAnuncio(item)}
                      className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50"
                      data-testid={`marketplace-admin-expire-${item.id}`}
                    >
                      <Clock3 className="h-4 w-4" /> Expirar
                    </button>
                    <button
                      onClick={() => openHistory(item)}
                      className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50"
                      data-testid={`marketplace-admin-history-${item.id}`}
                    >
                      <History className="h-4 w-4" /> Histórico
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </section>
        )}

        {/* Modal de detalhes do anúncio (admin) com lightbox de fotos */}
        </>
        )}

        {detailItem && (() => {
          const fotos = (detailItem.tipo === 'viatura' ? detailItem.detalhes?.fotos : []) || [];
          const idx = Math.min(photoIndex, Math.max(fotos.length - 1, 0));
          return (
            <div
              className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 p-3"
              onClick={() => setDetailItem(null)}
              data-testid="marketplace-admin-detail-modal"
            >
              <div
                className="relative max-h-[92vh] w-full max-w-4xl overflow-y-auto rounded-2xl bg-white shadow-2xl"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => setDetailItem(null)}
                  className="absolute right-3 top-3 z-10 rounded-full bg-white/95 p-2 text-slate-700 shadow ring-1 ring-slate-200 hover:bg-white"
                  data-testid="marketplace-admin-detail-close"
                  aria-label="Fechar"
                >
                  <X className="h-5 w-5" />
                </button>

                {/* Galeria */}
                {fotos.length > 0 && (
                  <div className="relative bg-slate-100">
                    <img
                      src={resolveImageUrl(fotos[idx])}
                      alt={`Foto ${idx + 1} de ${fotos.length}`}
                      className="max-h-[60vh] w-full object-contain"
                      data-testid="marketplace-admin-detail-photo"
                    />
                    {fotos.length > 1 && (
                      <>
                        <button
                          onClick={() => setPhotoIndex((idx - 1 + fotos.length) % fotos.length)}
                          className="absolute left-3 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-2 shadow hover:bg-white"
                          data-testid="marketplace-admin-detail-prev"
                          aria-label="Foto anterior"
                        >
                          <ChevronLeft className="h-5 w-5" />
                        </button>
                        <button
                          onClick={() => setPhotoIndex((idx + 1) % fotos.length)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-2 shadow hover:bg-white"
                          data-testid="marketplace-admin-detail-next"
                          aria-label="Próxima foto"
                        >
                          <ChevronRight className="h-5 w-5" />
                        </button>
                        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full bg-black/70 px-3 py-1 text-xs font-semibold text-white">
                          {idx + 1} / {fotos.length}
                        </div>
                      </>
                    )}
                    {fotos.length > 1 && (
                      <div className="flex gap-2 overflow-x-auto p-3" data-testid="marketplace-admin-detail-thumbs">
                        {fotos.map((src, i) => (
                          <button
                            key={i}
                            onClick={() => setPhotoIndex(i)}
                            className={`h-16 w-24 shrink-0 overflow-hidden rounded-lg border-2 ${i === idx ? 'border-emerald-500' : 'border-transparent'} `}
                          >
                            <img src={resolveImageUrl(src)} alt={`Miniatura ${i + 1}`} className="h-full w-full object-cover" />
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Dados */}
                <div className="space-y-3 p-5">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="text-xl font-extrabold text-slate-900" data-testid="marketplace-admin-detail-title">
                      {detailItem.titulo}
                    </h3>
                    <span className={`shrink-0 rounded-full px-3 py-1 text-xs font-semibold ${detailItem.status === 'aprovado' ? 'bg-emerald-100 text-emerald-700' : detailItem.status === 'suspenso' ? 'bg-amber-100 text-amber-700' : detailItem.status === 'rejeitado' ? 'bg-red-100 text-red-700' : 'bg-slate-100 text-slate-700'}`}>
                      {detailItem.status}
                    </span>
                  </div>

                  {detailItem.descricao && (
                    <p className="whitespace-pre-wrap text-sm text-slate-700">{detailItem.descricao}</p>
                  )}

                  <div className="grid gap-3 sm:grid-cols-2">
                    <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs">
                      <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">Anunciante</p>
                      <p className="mt-1 font-semibold text-slate-900">{detailItem.contacto?.primeiro_nome} {detailItem.contacto?.ultimo_nome}</p>
                      <p className="mt-0.5 text-slate-700">{detailItem.contacto?.email}</p>
                      <p className="text-slate-700">{detailItem.contacto?.telefone} {detailItem.contacto?.mostrar_telefone ? '' : '(privado)'}</p>
                      <p className="mt-1 text-slate-500">{detailItem.cidade}</p>
                    </div>
                    <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs">
                      <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">Pagamento</p>
                      <p className="mt-1 font-semibold text-slate-900">{detailItem.payment?.status || 'isento_lancamento'}</p>
                      <p className="text-slate-700">€ {Number(detailItem.payment?.paid_amount || 0).toFixed(2)} · {detailItem.payment?.paid_at ? detailItem.payment.paid_at.slice(0, 10) : '—'}</p>
                      {detailItem.expires_at && (
                        <p className="mt-1 text-slate-500">
                          Expira: {new Date(detailItem.expires_at).toLocaleDateString('pt-PT')} ({detailItem.duracao_dias || 30} dias)
                        </p>
                      )}
                    </div>
                  </div>

                  {detailItem.tipo === 'viatura' ? (
                    <div className="rounded-xl border border-emerald-100 bg-emerald-50/50 p-3 text-sm">
                      <p className="font-semibold text-emerald-800">
                        {detailItem.detalhes?.marca} {detailItem.detalhes?.modelo} ({detailItem.detalhes?.ano || '—'})
                      </p>
                      <p className="text-slate-700">
                        {detailItem.detalhes?.combustivel} · {detailItem.detalhes?.caixa} ·{' '}
                        <strong>{detailItem.detalhes?.valor_semanal}€ / semana</strong>
                      </p>
                    </div>
                  ) : (
                    <div className="rounded-xl border border-cyan-100 bg-cyan-50/50 p-3 text-sm">
                      <p className="text-slate-700">
                        Interesse: <strong>{detailItem.detalhes?.interesse}</strong> · Tipo: {detailItem.detalhes?.tipo_viatura} · {detailItem.detalhes?.combustivel}
                      </p>
                      {detailItem.detalhes?.valor_aluguer_maximo && (
                        <p className="text-slate-700">Aluguer máx: <strong>€{detailItem.detalhes.valor_aluguer_maximo}</strong></p>
                      )}
                      <p className="text-slate-500">Disponibilidade: {detailItem.detalhes?.disponibilidade} · {detailItem.detalhes?.tipo_turno}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })()}

        {selosModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" data-testid="marketplace-admin-selos-modal">
            <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
              <div className="mb-3 flex items-center justify-between">
                <h3 className="flex items-center gap-2 text-lg font-bold text-slate-900"><BadgeCheck className="h-5 w-5 text-emerald-700" /> Documentação verificada</h3>
                <button onClick={() => setSelosModal(null)} className="rounded-lg border border-slate-300 p-1 text-slate-500"><X className="h-4 w-4" /></button>
              </div>
              <p className="mb-3 text-xs text-slate-500">Anúncio: {selosModal.item?.titulo}. Selecione os documentos confirmados.</p>
              <div className="grid grid-cols-2 gap-2">
                {[['identidade', 'Identidade'], ['dua', 'DUA'], ['seguro', 'Seguro'], ['inspecao', 'Inspeção'], ['outro', 'Outro']].map(([v, l]) => (
                  <label key={v} className="flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-sm">
                    <input
                      type="checkbox"
                      checked={selosModal.docs.has(v)}
                      onChange={(e) => setSelosModal((s) => { const d = new Set(s.docs); e.target.checked ? d.add(v) : d.delete(v); return { ...s, docs: d }; })}
                      data-testid={`selos-doc-${v}`}
                    />
                    {l}
                  </label>
                ))}
              </div>
              <textarea
                className="mt-3 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                rows={2}
                placeholder="Notas internas (opcional)"
                value={selosModal.nota}
                onChange={(e) => setSelosModal((s) => ({ ...s, nota: e.target.value }))}
                data-testid="selos-nota"
              />
              <div className="mt-4 flex gap-2">
                <button onClick={() => saveSelosDocs(false)} className="rounded-xl border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700" data-testid="selos-remove">Remover selo</button>
                <button onClick={() => saveSelosDocs(true)} className="flex-1 rounded-xl bg-emerald-600 px-4 py-2 text-sm font-bold text-white hover:bg-emerald-700" data-testid="selos-save">Atribuir "Documentação verificada"</button>
              </div>
            </div>
          </div>
        )}


        {msgModal.open && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" data-testid="marketplace-admin-message-modal">
            <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-xl">
              <div className="mb-4 flex items-center justify-between">
                <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2">
                  <Mail className="h-5 w-5 text-cyan-700" />
                  Mensagem ao anunciante
                </h3>
                <button
                  onClick={() => setMsgModal({ open: false, item: null, assunto: '', corpo: '', sending: false })}
                  className="text-slate-500 hover:text-slate-700"
                  data-testid="marketplace-admin-message-close"
                >
                  ✕
                </button>
              </div>
              <p className="mb-3 text-xs text-slate-500">
                Para: <strong>{msgModal.item?.contacto?.email}</strong>
              </p>
              <input
                type="text"
                value={msgModal.assunto}
                onChange={(e) => setMsgModal((s) => ({ ...s, assunto: e.target.value }))}
                className="mb-3 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                placeholder="Assunto"
                data-testid="marketplace-admin-message-subject"
              />
              <textarea
                value={msgModal.corpo}
                onChange={(e) => setMsgModal((s) => ({ ...s, corpo: e.target.value }))}
                rows={7}
                className="mb-3 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                placeholder="Escreva a sua mensagem..."
                data-testid="marketplace-admin-message-body"
              />
              <p className="mb-3 text-[11px] text-slate-500">
                O email é enviado em nome do &quot;Marketplace TVDE&quot;.
              </p>
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setMsgModal({ open: false, item: null, assunto: '', corpo: '', sending: false })}
                  className="rounded-xl border border-slate-300 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
                >
                  Cancelar
                </button>
                <button
                  onClick={sendAdminMessage}
                  disabled={msgModal.sending}
                  className="inline-flex items-center gap-2 rounded-xl bg-cyan-600 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-700 disabled:opacity-60"
                  data-testid="marketplace-admin-message-send"
                >
                  {msgModal.sending ? 'A enviar...' : 'Enviar'}
                </button>
              </div>
            </div>
          </div>
        )}
        {historyModal.open && (
          <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/60 px-4" onClick={() => setHistoryModal({ open: false, item: null, entries: [], loading: false })} data-testid="marketplace-admin-history-modal">
            <div className="max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl" onClick={(e) => e.stopPropagation()}>
              <div className="mb-4 flex items-center justify-between">
                <h3 className="flex items-center gap-2 text-lg font-bold text-slate-900">
                  <History className="h-5 w-5 text-slate-700" /> Histórico / Auditoria
                </h3>
                <button onClick={() => setHistoryModal({ open: false, item: null, entries: [], loading: false })} className="text-slate-500 hover:text-slate-700" data-testid="marketplace-admin-history-close">
                  <X className="h-5 w-5" />
                </button>
              </div>
              <p className="mb-3 text-xs text-slate-500">{historyModal.item?.titulo}</p>
              {historyModal.loading ? (
                <p className="text-sm text-slate-600">A carregar histórico...</p>
              ) : historyModal.entries.length === 0 ? (
                <p className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-4 text-sm text-slate-600" data-testid="marketplace-admin-history-empty">Ainda sem registos de auditoria para este anúncio.</p>
              ) : (
                <ol className="space-y-2" data-testid="marketplace-admin-history-entries">
                  {historyModal.entries.map((e) => (
                    <li key={e.id} className="rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs">
                      <div className="flex flex-wrap items-center justify-between gap-2">
                        <span className="font-semibold text-slate-800">{e.acao}{e.de || e.para ? `: ${e.de || '—'} → ${e.para || '—'}` : ''}</span>
                        <span className="text-slate-500">{e.timestamp ? new Date(e.timestamp).toLocaleString('pt-PT') : ''}</span>
                      </div>
                      {e.nota && <p className="mt-1 text-slate-600">Nota: {e.nota}</p>}
                      <p className="mt-1 text-slate-500">Por: {e.admin_nome || e.admin_email || '—'}</p>
                    </li>
                  ))}
                </ol>
              )}
            </div>
          </div>
        )}
      </main>
      </div>
    </div>
  );
}
